import { useState, useEffect, useCallback } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;

export function useCMS() {
  const [content, setContent] = useState(cache || {});
  const [loading, setLoading] = useState(!cache);

  const fetchContent = useCallback(() => {
    if (cache) { setContent(cache); setLoading(false); return; }
    fetch(`${API}/content`)
      .then((r) => r.json())
      .then((data) => { cache = data; setContent(data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchContent();
  }, [fetchContent]);

  return { content, loading };
}
